/**
 * @fileoverview Agent definition for weakness-solutions-v1.
 *
 * Given a single diagnosed weakness (from story-weaknesses-v1) and the full
 * manuscript, proposes three distinct ways to solve it — an ideation step that
 * widens the author's option space rather than prescribing one fix.
 *
 * Powers the "Suggest solutions" action on the Weaknesses card.
 *
 * @category narrative.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'weakness-solutions-v1',
  kind: 'primitive',
  name: 'Weakness Solutions',
  description: 'Given a diagnosed story weakness and the full manuscript, proposes three distinct solutions, ordered from lightest-touch to most ambitious.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-05',
    lastUpdated: '2026-05',
    taxonomyPath: 'narrative.story.analysis',
    usedBy: [
      'primitives/use-weakness-solutions-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'story-weaknesses-v1',
    ],
  },
};
